<template>
    <div class="shop__error-message-block" v-if="ErrorMessageKey !== null">
        <ul>
            <li>{{Strings[ErrorMessageKey]}}</li>
        </ul>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import { CreateOfferOutcomes, CreateOrderOutcomes } from '@/utils/constants';

    export default {
        computed: {
            ...mapState([
                'Strings',
                'CreateOfferOutcome',
                'CreateOrderOutcome'
            ]),
            ErrorMessageKey() {
                if ((this.CreateOfferOutcome != null && this.CreateOfferOutcome == CreateOfferOutcomes.Unexpected)
                    || (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.Unexpected)
                )
                    return "Shop.Errors.GenericError";
                if (this.CreateOfferOutcome != null && this.CreateOfferOutcome == CreateOfferOutcomes.InvalidCoupon)
                    return "Shop.Errors.InvalidCoupon";
                if (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.OfferExpired)
                    return "Shop.Errors.OfferExpired";                
                if (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.OfferAlreadyOrderedOn)
                    return "Shop.Errors.OfferAlreadyOrdered";
                if (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.OfferNotFound)
                    return "Shop.Errors.OfferNotFound";
                if ((this.CreateOfferOutcome != null && this.CreateOfferOutcome == CreateOfferOutcomes.PricesExpired)
                    || (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.PricesExpired)
                )
                    return "Shop.Errors.PriceExpired";
                if ((this.CreateOfferOutcome != null && this.CreateOfferOutcome == CreateOfferOutcomes.ShopDisabled)
                    || (this.CreateOrderOutcome != null && this.CreateOrderOutcome == CreateOrderOutcomes.ShopDisabled)
                )
                    return "Shop.PricingDisabled.Text";
                return null;
            }
        }
    };
</script>